import styled from 'styled-components';

export const Button = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  text-decoration: underline;
`;

export const ButtonLink = styled.a`
  color: #4b286d;
`;

export const LockedLabel = styled.div`
  font-size: 14px;
  color: #71757b;
  font-weight: 500;
`;
